import LoginContent from "page_components/auth/login/Content";

const Login = () => {
  return <LoginContent />;
};

export default Login;
